const modalContainer = document.querySelector("#novada_modal")
const linksWithModal = Array.from(document.querySelectorAll('a[data-open-modal]'))
if (linksWithModal.length > 0 && modalContainer) {
  const contentContainer = modalContainer.querySelector('.content')
  const closeBtn = modalContainer.querySelector('.close')
  closeBtn.addEventListener('click', (e) => {
    e.preventDefault()
    closeModal()
  })

  contentContainer.addEventListener('click', (e) => {
    e.stopPropagation()
  })

  modalContainer.addEventListener('click', (e) => {
    e.preventDefault()
    closeModal()
  })

  document.addEventListener('keydown', (e) => {
    evt = e || window.event
    if ("key" in evt) {
      if (evt.key === 'Escape' || evt.key === 'Esc') {
        closeModal()
      }
    } else {
      if (evt.keyCode === 27) {
        closeModal()
      }
    }
  })

  linksWithModal.forEach(linkModal => {

    linkModal.addEventListener('click', (e) => {
      e.preventDefault()
      e.stopPropagation()

      fetch(e.target.href)
        .then(response => response.text())
        .then(html => {
          let parser = new DOMParser();
          let htmlDoc = parser.parseFromString(html, 'text/html');
          const content = htmlDoc.querySelector('body #novada_app main.body');
          contentContainer.innerHTML = ''
          contentContainer.appendChild(content)

          openModal()
        })
        .catch(error => {
          console.log(error)
          window.open(e.target.href, '_blank')
        })
    })
  })
}

const openModal = () => {
  modalContainer.classList.add('open')
}

const closeModal = () => {
  modalContainer.classList.remove('open')
}
